import { createSlice } from "@reduxjs/toolkit";

// const init = sessionStorage.getItem( 'febactive' ) || ['home'];
// console.log('init', init);

const ActiveSlice = createSlice({
    name: "menu-active",
    initialState: [],
    reducers: {
        makeActive (state, action) {
            state.splice(0,1, action.payload);
            sessionStorage.setItem("febactive", [action.payload]);
            // console.log('makeACTIVE');
        },
        fetchPage (state, action) {
            // console.log('ap', action.payload);
            if (action.payload === "home") {
                state.splice(0,1, 'home');
            } else if (action.payload === 'lr') {
                state.splice(0,1, 'lr');
            } else if (action.payload === "product") {
                state.splice(0,1, 'product');
            } else if (action.payload === "proditem") {
                state.splice(0,1, 'proditem');
            } else if (action.payload === 'help') {
                state.splice(0,1, 'help');
            } else if (action.payload === 'cartorder') {
                state.splice(0,1, 'cartorder');
            } else if (action.payload === 'profile') {
                state.splice(0,1, 'profile');
            } else if (action.payload === 'cart') {
                state.splice(0,1, 'cart');
            } else if (action.payload === 'order') {
                state.splice(0,1, 'order');
            } 
        },
        // removeUser (state, action) { },
        // deleteUsers (state, action) { },
    },
});

export default ActiveSlice.reducer;

export const {makeActive, fetchPage} = ActiveSlice.actions;